import { Button } from '@cottage/design-system/internal-tooling/ui'

type ApplyRecipeConfirmProps = {
  sourceMonthLabel: string
  formattedValue: string
  onCancel: () => void
  onKeepShape: () => void
  onReplaceFlat: () => void
}

export default function ApplyRecipeConfirm({
  sourceMonthLabel,
  formattedValue,
  onCancel,
  onKeepShape,
  onReplaceFlat,
}: ApplyRecipeConfirmProps) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="apply-recipe-confirm-title"
        className="relative w-full max-w-md rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="apply-recipe-confirm-title" className="text-sm font-semibold text-gray-900">
          Apply to later months
        </h3>
        <div className="mt-4 space-y-3">
          <Button variant="primary" size="md" className="w-full text-left" onClick={onKeepShape}>
            Keep the shape — set the baseline so {sourceMonthLabel} equals {formattedValue} and keep
            the path, growth and seasonality
          </Button>
          <Button variant="outline" size="md" className="w-full" onClick={onReplaceFlat}>
            Replace with a flat value
          </Button>
        </div>
        <div className="mt-5 flex justify-end">
          <Button variant="outline" size="md" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  )
}
